require('./').polyfill()



//////////////////
// WEBPACK FOOTER
// ./node_modules/raf/polyfill.js
// module id = 253
// module chunks = 1